import { useEffect } from "react";
import {useLocation} from "react-router-dom";

// Функция для прокрутки страницы в начало при переходе на новую страницу
export default function ScrollToTop(){
    const {pathname} = useLocation();
    
    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'instant' as ScrollBehavior});
    }, [pathname]);
    
    return null;
}